// extracted by mini-css-extract-plugin
module.exports = {"link":"g5pLg","root":"_2GK65","label":"_2iJvO"};